module.exports = __webpack_public_path__ + "img/LOGO2.9b6dd01b.jpg";